export const statusKeys = {
  READY: 'Ready for submission',
  SUBMITTED: 'Submitted',
  ERROR: 'Error'
};

export const statusLabels = {
  [statusKeys.READY]: 'Ready for Submission',
  [statusKeys.SUBMITTED]: 'Submitted',
  [statusKeys.ERROR]: 'Contains Errors'
};

export const statuses = [
  {
    label: statusLabels[statusKeys.READY],
    value: statusKeys.READY,
    key: 'readyForSubmit'
  },
  {
    label: statusLabels[statusKeys.SUBMITTED],
    value: statusKeys.SUBMITTED,
    key: 'submited'
  },
  {
    label: statusLabels[statusKeys.ERROR],
    value: statusKeys.ERROR,
    key: 'errors'
  }
];
